export const isURLValid = (url) => {
  if (!url || typeof url !== 'string') return false;
  const urlRegex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+[/#?]?.*)?$/;
  return /^https?:\/\//.test(url) && urlRegex.test(url);
};

export const isTitleValid = (title) => {
  const titleRegex = /^[A-Za-z][A-Za-z0-9\s]*$/;
  return titleRegex.test(title);
};
